<template>
  <v-card>
    <v-tabs v-model="tab" background-color="primary" dark grow>
      <v-tab v-for="item in getTabItems" :key="item.tab">{{ item.tab }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in getTabItems" :key="item.tab">
        <v-data-table
          :headers="headers"
          :items="item.content"
          :items-per-page="5"
          class="elevation-1"
        >
          <template v-slot:item.action="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">login</v-icon>
              </template>
              <span>Vezi client</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
export default {
  name: 'ListCurrent',
  data() {
    return {
      tab: null,

      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Nume',
          align: 'center',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Adresa',
          align: 'center',
          value: 'addressDetails',
          sortable: true,
        },
        {
          text: 'Telefon',
          align: 'center',
          value: 'phone',
          sortable: true,
        },
        {
          text: 'Revizie',
          align: 'center',
          value: 'revisionDate',
          sortable: true,
        },
        {
          text: 'Verificare',
          align: 'center',
          value: 'checkDate',
          sortable: true,
        },
        {
          text: 'Client',
          value: 'action',
          sortable: false,
        },
      ],
      pagination: {
        itemsPerPage: 2,
      },
    };
  },
  created() {
    this.$store.dispatch('clients/getCurrentChecks');
    this.$store.dispatch('clients/getCurrentRevisions');
  },
  computed: {
    getTabItems() {
      return [
        { tab: 'Verificari', content: this.$store.state.clients.checks },
        { tab: 'Revizii', content: this.$store.state.clients.revisions },
      ];
    },
  },
  methods: {
    editItem(item) {
      const { id } = item;
      this.$router.push({ name: 'Editare client', params: { id } });
    },
  },
};
</script>
